/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/dot-notation */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// import { PushNotificationService } from './push-notification.service';
import { environment } from 'src/environments/environment';
import { FlightGroup, Trolley } from '../data/new-models';
import { BaseResponse } from '../models/base.response';
import { DropdownData } from '../models/dropdown-data.model';
import { FlightLoad } from '../models/flight-load.model';
import { AddDrawerItemRequest, FlightProduct } from '../models/flight-product.model';
import { AddFlightGroupRequest, AddFlightRequest, ChangeSealRequest, FilterOptions, SwapRequest } from '../models/flight.model';
import { UpdateCheckRequest } from '../models/update-check.model';

const endpoints = {
  addTrolley: (flightGroupId: string) => '/flight/add-trolley/' + flightGroupId,
  // eslint-disable-next-line max-len
  uploadDrawerPhoto: (trolleyId: string, side: string, drawerId) => '/flight/v2/upload-drawer-photo/' + trolleyId + '/' + side + '/' + drawerId,
  deleteDrawerPhoto: (trolleyId: string, side: string, imageId: string) =>
    '/flight/delete-drawer-photo/' + trolleyId + '/' + side + '/' + imageId,
  getAll: (startDate: string, endDate: string) => {
    const queryObj = {
      perPage: '5000'
    };
    if (startDate) {
      queryObj['startDate'] = startDate;
    }
    if (endDate) {
      queryObj['endDate'] = endDate;
    }
    const path = '/flight?';
    return path + new URLSearchParams(queryObj).toString();
  },
  getFlightDetails: (flightGroupId: string, reqReturn: boolean) => '/flight/v2/detail/' + flightGroupId + (reqReturn !== null ? ('?reqReturn=' + (reqReturn ? '1' : '0')) : ''),
  closeTrolleySide: (trolleyId: string) => '/flight/v2/close-trolley-side/' + trolleyId,
  unlockTrolleySide: (trolleyId: string) => '/flight/unlock-side/' + trolleyId,
  closeTrolley: (trolleyId: string) => '/flight/v2/close-trolley/' + trolleyId,
  closeFlight: (flightGroupId: string) => '/flight/close-flight/' + flightGroupId,
  getTrolleysByflightGroupId: (flightGroupId: string) => '/flight/trolleys/' + flightGroupId,
  updateCheckCount: (trolleyId: string) => '/flight/update-check-count/' + trolleyId,
  updateUncountableCheckCount: '/flight/update-uc-check-count',
  addUncountableProduct: (trolleyId: string) => '/flight/add-uncountable-product/' + trolleyId,
  deleteTrolley: (trolleyId: string) => '/flight/trolley/' + trolleyId,
  resetFlight: (flightGroupId: string) => '/flight/reset/' + flightGroupId,
  getFlightProducts: (flightGroupId: string) => '/flight/flight-products/' + flightGroupId,
  addDrawerItem: (flightGroupId: string) => '/flight/add-custom-drawer-item/' + flightGroupId,
  addFlight: '/flight/add-custom-flight',
  getFilterOptions: '/flight/filter-options',
  changeSealNumber: '/flight/change-seal-number',
  getFlightLoads: (startDate: string, endDate: string) => {
    const queryObj = {};
    if (startDate) {
      queryObj['startDate'] = startDate;
    }
    if (endDate) {
      queryObj['endDate'] = endDate;
    }
    const path = '/flight-group/flight-loads?';
    return path + new URLSearchParams(queryObj).toString();
  },
  getDropdownData: '/flight-group/dropdown-data',
  addFlightGroup: '/flight-group',
  swap: '/flight-group/swap'
};

@Injectable()
export class FlightService {

  constructor(
    private http: HttpClient,
  //  private pushNotification: PushNotificationService
  ) { }



  async addTrolley(flightGroupId: string): Promise<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.addTrolley(flightGroupId);
    const res = await this.http.post<BaseResponse<Trolley>>(url, {}).toPromise();
    return Promise.resolve(res);
  }

  // eslint-disable-next-line max-len
  async uploadDrawerPhoto(file: File, trolleyId: string, side: string, extension: string, drawerId: string): Promise<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.uploadDrawerPhoto(trolleyId, side, drawerId);
    const formData = new FormData();
    formData.append('file', file, 'drawer_' + +(new Date()) + '.' + extension);
    const res = await this.http.post<BaseResponse<Trolley>>(url, formData).toPromise();
    return Promise.resolve(res);
  }

  async deletedDrawerPhoto(trolleyId: string, side: string, imageId: string): Promise<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.deleteDrawerPhoto(trolleyId, side, imageId);
    const res = await this.http.post<BaseResponse<Trolley>>(url, {}).toPromise();
    return Promise.resolve(res);
  }

  async getAll(startDate: string, endDate: string): Promise<BaseResponse<FlightGroup[]>> {
    const url = environment.apiBaseUrl + endpoints.getAll(startDate, endDate);
    const res = await this.http.get<BaseResponse<FlightGroup[]>>(url).toPromise();
    return Promise.resolve(res);
  }

  async getFlightDetails(flightGroupId: string, reqReturn: boolean = null): Promise<BaseResponse<FlightGroup>> {
    const url = environment.apiBaseUrl + endpoints.getFlightDetails(flightGroupId, reqReturn);
    const res = await this.http.get<BaseResponse<FlightGroup>>(url).toPromise();
    return Promise.resolve(res);
  }

  async closeTrolleySide(trolleyId: string, side: string, sealNumber?: string): Promise<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.closeTrolleySide(trolleyId);
    const res = await this.http.post<BaseResponse<Trolley>>(url, { side, sealNumber }).toPromise();
    return Promise.resolve(res);
  }

  unlockTrolleySide(trolleyId: string, side: string, sealNumber?: string): Observable<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.unlockTrolleySide(trolleyId);
    return this.http.post<BaseResponse<Trolley>>(url, { side, sealNumber });
  }

  closeTrolley(trolleyId: string): Observable<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.closeTrolley(trolleyId);
    return this.http.post<BaseResponse<Trolley>>(url, {});
  }

  closeFlight(flightGroupId: string): Observable<BaseResponse<FlightGroup>> {
    const url = environment.apiBaseUrl + endpoints.closeFlight(flightGroupId);
    return this.http.post<BaseResponse<FlightGroup>>(url, {});
  }

  updateCheckCount(payload: UpdateCheckRequest): Observable<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.updateCheckCount(payload.trolleyId);
    return this.http.post<BaseResponse<Trolley>>(url, payload);
  }

  updateUncountableCheckCount(payload: UpdateCheckRequest): Observable<BaseResponse<any>> {
    const url = environment.apiBaseUrl + endpoints.updateUncountableCheckCount;
    return this.http.post<BaseResponse<any>>(url, payload);
  }

  addUncountableProduct(payload: UpdateCheckRequest): Observable<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.addUncountableProduct(payload.trolleyId);
    return this.http.post<BaseResponse<Trolley>>(url, payload);
  }

  async deleteTrolley(trolleyId: string): Promise<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.deleteTrolley(trolleyId);
    const res = await this.http.delete<BaseResponse<Trolley>>(url).toPromise();
    return Promise.resolve(res);
  }

  resetFlight(flightGroupId: string): Observable<BaseResponse<FlightGroup>> {
    const url = environment.apiBaseUrl + endpoints.resetFlight(flightGroupId);
    return this.http.post<BaseResponse<FlightGroup>>(url, {});
  }

  async getFlightProducts(flightGroupId: string): Promise<BaseResponse<FlightProduct[]>> {
    const url = environment.apiBaseUrl + endpoints.getFlightProducts(flightGroupId);
    const res = await this.http.get<BaseResponse<FlightProduct[]>>(url).toPromise();
    return Promise.resolve(res);
  }

  addDrawerItem(payload: AddDrawerItemRequest, flightGroupId: string): Observable<BaseResponse<Trolley>> {
    const url = environment.apiBaseUrl + endpoints.addDrawerItem(flightGroupId);
    return this.http.post<BaseResponse<Trolley>>(url, payload);
  }

  async addFlight(payload: AddFlightRequest): Promise<BaseResponse<FlightGroup>> {
    const url = environment.apiBaseUrl + endpoints.addFlight;
    const res = await this.http.post<BaseResponse<FlightGroup>>(url, payload).toPromise();
    return Promise.resolve(res);
  }

  async getFilterOptions(): Promise<FilterOptions> {
    const url = environment.apiBaseUrl + endpoints.getFilterOptions;
    const res = await this.http.get<FilterOptions>(url).toPromise();
    return Promise.resolve(res);
  }

  changeSealNumber(payload: ChangeSealRequest): Observable<BaseResponse<any>> {
    const url = environment.apiBaseUrl + endpoints.changeSealNumber;
    return this.http.post<BaseResponse<any>>(url, payload);
  }

  async getFlightLoads(startDate: string, endDate: string): Promise<BaseResponse<FlightLoad[]>> {
    const url = environment.apiBaseUrl + endpoints.getFlightLoads(startDate, endDate);
    const res = await this.http.get<BaseResponse<FlightLoad[]>>(url).toPromise();
    return Promise.resolve(res);
  }

  async getDropdownData(): Promise<BaseResponse<DropdownData>> {
    const url = environment.apiBaseUrl + endpoints.getDropdownData;
    const res = await this.http.get<BaseResponse<DropdownData>>(url).toPromise();
    return Promise.resolve(res);
  }

  async addFlightGroup(payload: AddFlightGroupRequest): Promise<BaseResponse<{ orderNo: string }>> {
    const url = environment.apiBaseUrl + endpoints.addFlightGroup;
    const res = await this.http.post<BaseResponse<{ orderNo: string }>>(url, payload).toPromise();
    return Promise.resolve(res);
  }

  async swap(payload: SwapRequest): Promise<BaseResponse<{ orderNo: string }>> {
    const url = environment.apiBaseUrl + endpoints.swap;
    const res = await this.http.post<BaseResponse<{ orderNo: string }>>(url, payload).toPromise();
    return Promise.resolve(res);
  }

}
